// extracted by mini-css-extract-plugin
export default {"cursor":"CustomCursor_cursor__NgVfE"};